function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__ic_big_shield-a",
  d: "M51.74 6l.678 1.163a24.661 24.661 0 0 0 8.89 8.89l1.162.677v9.285a44.133 44.133 0 0 1-7.877 25.226A44.324 44.324 0 0 1 37.242 66.02l-1.007.48-1.007-.48a44.322 44.322 0 0 1-17.35-14.779A44.135 44.135 0 0 1 10 26.015V16.73l1.163-.678a24.661 24.661 0 0 0 8.89-8.889L20.73 6h31.01zm-2.654 4.684H23.385a29.348 29.348 0 0 1-8.7 8.701v6.63c0 8.1 2.435 15.9 7.044 22.56a39.654 39.654 0 0 0 14.506 12.719 39.652 39.652 0 0 0 14.506-12.718 39.47 39.47 0 0 0 7.045-22.561v-6.63a29.38 29.38 0 0 1-8.7-8.7zm-12.851 8.9c5.15 0 9.339 4.19 9.339 9.34 0 4.34-2.977 8-6.997 9.04v8.452h-4.684v-8.451c-4.02-1.042-6.997-4.7-6.997-9.041 0-5.15 4.19-9.34 9.339-9.34zm0 4.685a4.66 4.66 0 0 0-4.655 4.655 4.66 4.66 0 0 0 4.655 4.654 4.66 4.66 0 0 0 4.655-4.654 4.66 4.66 0 0 0-4.655-4.655z"
}));

var _ref3 = /*#__PURE__*/React.createElement("use", {
  fillRule: "evenodd",
  xlinkHref: "#prefix__ic_big_shield-a"
});

var SvgIcBigShield = function SvgIcBigShield(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 72 72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcBigShield, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_big_shield.5ba8bc07.svg";
export { ForwardRef as ReactComponent };